module.exports = __webpack_public_path__ + "static/media/AgregarArea.3cef8f08.png";